
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.8 1.067c-.955 0-1.733.777-1.733 1.733 0 .956.778 1.733 1.733 1.733.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733zM2.8 6.267c-.955 0-1.733.777-1.733 1.733 0 .956.778 1.733 1.733 1.733.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733zM2.8 11.467c-.955 0-1.733.777-1.733 1.733 0 .956.778 1.733 1.733 1.733.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733zM8 1.067c-.955 0-1.733.777-1.733 1.733 0 .956.778 1.733 1.733 1.733.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733zM8 6.267c-.955 0-1.733.777-1.733 1.733 0 .956.778 1.733 1.733 1.733.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733zM8 11.467c-.955 0-1.733.777-1.733 1.733 0 .956.778 1.733 1.733 1.733.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733zM13.2 4.533c.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733-.955 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733zM13.2 6.267c-.955 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733zM13.2 11.467c-.955 0-1.733.777-1.733 1.733 0 .956.777 1.733 1.733 1.733.956 0 1.734-.777 1.734-1.733 0-.956-.778-1.733-1.734-1.733z","fill":"currentColor"}})])
          )
        }
      }
    